<template>
    <main class="news all_posts">

        <article class="news news2">
            <ArticleLogo />
        </article>
        <PredictionMenu />
        ashjid
        <ul class="fixtures p-fixtures prediction">
            <h5 v-if="current_user == name" class="league-info-header predict-info-header">Your Previous Predictions</h5>
            <h5 v-else class="league-info-header predict-info-header">{{ name }}'s Previous Predictions</h5>

            <PredictionComplete v-for="game in games" :key="game.id" :game="game['finished_match']"
                :check="game['finished_prediction']" />
            <div class="more-h">
                <button @click="loadMoreRows()" v-if="button" class="button_submit more-pre">Load more</button>
            </div>
            <h5 class="league-info-header predict-info-header">User Rank</h5>

            <UserRank :player="points" />
        </ul>
    </main>
</template>

<script>
import PredictionMenu from '@/components/predictions/PredictionMenu.vue'
import ArticleLogo from '../components/ArticleLogo.vue'
import PredictionComplete from '@/components/predictions/PredictionComplete.vue'
import UserRank from '@/components/predictions/UserRank.vue'

export default {
    name: 'PredictionHistory',
    components: { ArticleLogo, PredictionMenu, PredictionComplete, UserRank },
    inject: ['backendServer', 'currentHost', 'current_user'],
    data() {
        return {
            button: true,
            games: null,
            name: null,
            points: null
        }
    },
    methods: {
        pregressPrediction() {
            let id = window.location.href.split('/').pop()


            fetch(this.backendServer() + '/prediction-history/' + id, {
                method: "GET",
                mode: "cors",
                cache: "no-cache",
                credentials: "include",

                redirect: "follow",
                referrerPolicy: "no-referrer",
            })
                .then((response) => response.json())
                .then((data) => {
                    this.name = data.name
                    this.games = data.all_matches
                    this.points = data.points

                });
        }
    },
    mounted() {
        document.title = 'Prediction History / Rossoneries';

        this.pregressPrediction()
    }

}
</script>

<style >
div.more-h {
    width: 100%;
}
</style>